import axios from "axios";
import getEndpoint from "../getEndpoint";

const ngrokSkipWarning = { headers: { "bypass-tunnel-reminder": "true" } };

export async function LoginUser(credentials: any) {
  const response = await axios.post(`${getEndpoint()}/api/Authentication/Login`, credentials, ngrokSkipWarning);
  return response.data;
}

export async function RegisterUser(credentials: any) {
  const response = await axios.post(`${getEndpoint()}/api/Authentication/Register`, credentials, ngrokSkipWarning);
  return response.data;
}

export async function handleRequestOtp(email: string) {
  try {
    const response = await axios.post(`${getEndpoint()}/api/Authentication/RequestOtp`, { email },{ 
      headers: { "bypass-tunnel-reminder": "true" } ,
      withCredentials: true,
    } );
    return { success: true, message: "OTP sent to your email.", data: response.data };
  } catch (error) {
    return { success: false, message: "Failed to send OTP. Please try again.", error };
  }
}

export async function handleVerifyOtp(email: string, otp: string) {
  try {
    const response = await axios.post(`${getEndpoint()}/api/Authentication/VerifyOtp`, { email, otp }, { 
      headers: { "bypass-tunnel-reminder": "true" } ,
      withCredentials: true,
    } );
    return { success: true, message: "OTP verified. You can now reset your password.", data: response.data };
  } catch (error) {
    return { success: false, message: "Invalid OTP. Please try again.", error };
  }
}

export async function handleResetPassword(email: string, otp: string, newPassword: string) {
  try {
    const response = await axios.post(`${getEndpoint()}/api/Authentication/ResetPassword`, { email, otp, newPassword }, { 
      headers: { "bypass-tunnel-reminder": "true" } ,
      withCredentials: true,
    } );
    return { success: true, message: "Password reset successfully. You can now log in.", data: response.data };
  } catch (error) {
    return { success: false, message: "Failed to reset password. Please try again.", error };
  }
}

export async function notifyOrder(id:string) {
  try {
    const response = await axios.post(`${getEndpoint()}/api/Authentication/NotifyOrder?id=${id}`, {}, ngrokSkipWarning);
    return { success: true, message: "Notification email sent successfully.", data: response.data };
  } catch (error) {
    return { success: false, message: "Failed to send notification email.", error };
  }
}

export async function NotifyCustomerOrder(id:any, email:any) {
  try {
    const response = await axios.post(
      `${getEndpoint()}/api/Authentication/NotifyCustomerOrder?id=${(id)}&email=${(email)}`,{},ngrokSkipWarning
    );
    return { success: true, message: "Notification email sent successfully.", data: response.data };
  } catch (error) {
    return { success: false, message: "Failed to send notification email. Please try again.", error };
  }
}

export async function NotifyStatusUpdate(id: string, email: string, newStatus: string) {
  try {
      const response = await axios.post(
          `${getEndpoint()}/api/Authentication/NotifyStatusUpdate?id=${(id)}&email=${(email)}&newStatus=${(newStatus)}`,{},ngrokSkipWarning
      );
      return { success: true, message: "Notification email sent successfully.", data: response.data };
  } catch (error) {
      return { success: false, message: "Failed to send notification email. Please try again.", error };
  }
}
